import React, { createContext, useContext, useEffect, useState } from "react";

export const THEMES = [
  { key: "earthy", name: "A · Warm & erdig", subtitle: "Terracotta + Sage", swatches: ["#B75D46", "#8A9A86", "#F9F6F0"] },
  { key: "elegant", name: "B · Elegant & minimalistisch", subtitle: "Creme + Gold", swatches: ["#B8905A", "#9B8E7E", "#FAF7F0"] },
  { key: "natural", name: "C · Natürlich & ruhig", subtitle: "Sage + Holz", swatches: ["#6B7A60", "#8B6B47", "#F4EDE0"] },
];

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState("earthy");

  useEffect(() => {
    if (typeof document === "undefined") return;
    document.documentElement.removeAttribute("data-theme");
    try { localStorage.removeItem("site_theme"); } catch (e) {}
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme: setThemeState, themes: THEMES }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme must be used within ThemeProvider");
  return ctx;
};
